module.exports = __webpack_public_path__ + "img/20200307145752860.7f52f8da.jpg";